import { BotFlow, NlpSettings, StepSchema } from '@feedyou/schema'
import { createDuplicateIdsValidator } from './createDuplicateIdsValidator'

import {
  BOT_UNIQUE_IDS_SCHEMA,
  NLP_SETTINGS_UNIQUE_IDS_SCHEMA,
  STEP_UNIQUE_IDS_SCHEMA
} from '../constants/uniqueIdsSchema'

export const validateAndFixDuplicateIdsInStep = createDuplicateIdsValidator<StepSchema>(
  STEP_UNIQUE_IDS_SCHEMA,
  'step'
)

export const validateAndFixDuplicateIdsInBot = createDuplicateIdsValidator<BotFlow>(
  BOT_UNIQUE_IDS_SCHEMA,
  'bot'
)

export const validateAndFixDuplicateIdsInNlpSettings = createDuplicateIdsValidator<NlpSettings>(
  NLP_SETTINGS_UNIQUE_IDS_SCHEMA,
  'nlp settings'
)
